import type { DataContainer } from "@otto-ec/tracking-bct";
import { ActivationStatus, type Detailview } from "../Detailview";

export type TrackingFeatureStatus = "loaded" | "clicked" | "hidden" | "visible";
type TrackingEventAction = "add" | "open" | "close" | "change" | "scroll" | "swipe" | "click";

export interface TrackingEvent {
	readonly name: TrackingEventAction;
	readonly features: (TrackingFeature | TrackingFeatureChild)[];
}

export interface TrackingFeature {
	readonly id: string;
	readonly name: string;
	readonly status: TrackingFeatureStatus;
}

export interface TrackingFeatureChild {
	readonly id: string;
	readonly name: string;
	readonly status: TrackingFeatureStatus;
	readonly labels: DataContainer;
	readonly parentId: string;
}

export function createTrackingEvent(action: TrackingEventAction, trackingPayload: (TrackingFeature | TrackingFeatureChild)[]): TrackingEvent {
	return { name: action, features: trackingPayload };
}

export function createTrackingEventPayload(benefit: Detailview, status: TrackingFeatureStatus, success?: boolean): (TrackingFeature | TrackingFeatureChild)[] {
	const parentId = `FT9-benefit-detailview-${benefit.variationId}`;

	const detailviewTrackingPayload: TrackingFeature = {
		id: parentId,
		name: "BenefitDetailview",
		status: status,
	};

	const labels = benefit.tracking.labels;

	if (success === false) {
		labels.benefit_Activation = ["error"];
	} else if (success || benefit.activationStatus === ActivationStatus.ACTIVATED) {
		labels.benefit_Activation = ["on"];
	} else {
		labels.benefit_Activation = ["off"];
	}

	if (status === "clicked" && benefit.isAppOnly) {
		labels.benefit_AppOnlyClick = ["true"];
	}

	const benefitTrackingPayload: TrackingFeatureChild = {
		id: `${benefit.tracking.id}-${benefit.variationId}`,
		name: benefit.tracking.name,
		status: status,
		labels: labels,
		parentId: parentId,
	};

	return [detailviewTrackingPayload, benefitTrackingPayload];
}
